/**
 * 側欄〈審核〉徽章的共享數字（批153 批B）。
 *
 * 側欄（`AppShell`）每 60 秒輪詢一次 `GET /reviews`；審核頁自己載入或核准／婉拒之後也寫這裡，
 * 徽章當場跟著變——不必等下一輪輪詢。刻意是模組層級的一個 ref 而不是放進 `stores/data`：
 * 這只是一個數字，不值得讓那支共用 store 多一個載入器。
 */
import { readonly, ref } from 'vue'

const count = ref(0)

export const pendingReviews = readonly(count)

export function setPendingReviews(n: number): void {
  count.value = Number.isFinite(n) && n > 0 ? Math.floor(n) : 0
}
